<div class="container" [ngSwitch]="mode">
  <div *ngSwitchDefault>
  <form [formGroup]="stateForm" (ngSubmit)="onSubmit($event)" class="post">
    <div class="post">
      <div class="title">Send For Review</div>
      <div class="form">
        <span class="input">
          <mat-form-field>
          <mat-label>Select Dr.</mat-label>
          <mat-select [(ngModel)]="selectedDr" (selectionChange)="slectOnChange($event)" matNativeControl [ngModelOptions]="{standalone: true}">
              <mat-option *ngFor="let dr of drs" [value]="dr.name">{{dr.name}}</mat-option>
          </mat-select>
          </mat-form-field>
      </span>

        <span class="input">
          <!-- <mat-form-field>
              <mat-label>Title</mat-label>
              <input formControlName="Title" matInput placeholder="">
            </mat-form-field> -->
        </span>
      </div>
      <div class="" style="margin-bottom: 30px; display: flex; justify-content: center;">
        <button class="create" type="submit" mat-raised-button color="primary" style="margin: 30px auto;">
          {{ isLoading? "Sending...": "Send"}}
        </button>
      </div>
    </div>
  </form>

</div>
